import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const DirectDebitExportModal = Record({
    isVisible: false,
    preparingFile: false,
    addPayments: true,
    invoiceIds: List(),
    institutionId: undefined,
    directDebitLink: '',
});

export default handleActions(
    {
        [Actions.show.type]: (state, {payload}) =>
            state.merge({
                isVisible: true,
                invoiceIds: payload.invoiceIds,
                institutionId: payload.institutionId,
            }),
        [Actions.getFile.type]: state =>
            state.merge({
                preparingFile: true,
            }),
        [Actions.getFileFailed.type]: state =>
            state.merge({
                preparingFile: false,
            }),
        [Actions.getFileSuccess.type]: (state, {payload}) =>
            state.merge({
                directDebitLink: payload.data.csv,
                preparingFile: false,
            }),
        [Actions.toggleAddPayments.type]: (state, {payload}) =>
            state.merge({
                addPayments: payload.addPayments,
            }),
        [Actions.hide.type]: () => new DirectDebitExportModal(),
    },
    new DirectDebitExportModal(),
);
